"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const Box_1 = require("../Box");
const Flex_1 = require("../Flex");
function Spinner(_a) {
    var { size = '2xl' } = _a, props = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(Flex_1.Flex, Object.assign({}, props, { children: jsx_runtime_1.jsx(Box_1.Box, Object.assign({ m: "auto", fontSize: size }, { children: jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSpinner, spin: true }, void 0) }), void 0) }), void 0));
}
exports.Spinner = Spinner;
//# sourceMappingURL=index.js.map